<template>
    <!-- <v-card tile>
        <v-card-title class="subtitle-1 font-weight-bold px-6">
            {{ translations.cancelRedemption[lang] }}
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('cancel')">
                <v-icon v-text="icons.mdiClose"></v-icon>
            </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pt-4 pb-1">
           
        </v-card-text>
    </v-card> -->
 <b-card
        :title="translations.cancelRedemption[lang]"
        @cancel="$emit('cancel')"
        @submit="cancelGift(cancelGiftData.transaction_id) && $emit('cancel')"
        :error-message="''"
        :loading="false"
        :disabled="false"
        :submit-text="{ el: 'Επιβεβαίωση Ακύρωσης', en: 'Confirm Cancelation', it: 'Confirm Cancelation' }"
        :cancel-text="{ el: 'Κλείσιμο', en: 'Close', it: 'Close' }"
    >
        <v-sheet
            class="pa-3 mb-3"
            >
                {{ translations.cancelRedemptionText[lang] }}
        </v-sheet>

        <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{ translations.giftTitle[lang] }}:
                {{ ' ' + cancelGiftData.gift_title ? cancelGiftData.gift_title : "-" }}
            </v-sheet>

            <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{ translations.mobile[lang] }}:
                {{ ' ' + cancelGiftData.mobile ? cancelGiftData.mobile : "-" }}
            </v-sheet>
    </b-card>
</template>

<script>
import { mdiClose } from "@mdi/js";

import { mapState, mapMutations, mapActions } from "vuex";
import translations from "@/utils/translations/loyaltyPanel/redemptions";

export default {
    name: "AdditionalInfo",

    mixins: [translations],

    data: () => ({
        icons: { mdiClose },
    }),

    methods: {
        ...mapActions("loyaltyPanel/redemptions", ["cancelGift"]),
        ...mapMutations("loyaltyPanel/redemptions",["setCancelGiftData"]),
    },
    computed: {
        ...mapState("loyaltyPanel/redemptions", ["cancelGiftData"]),

        lang() {
            return this.$route.params.lang;
        },

        customerData() {           
            return this.$store.state.loyaltyPanel.customers.customerData;  
        },
    }
};
</script>
